module.exports = __webpack_public_path__ + "src/components/Feedback/phone-call.svg?db8614ea";


//////////////////
// WEBPACK FOOTER
// ./src/components/Feedback/phone-call.svg
// module id = 3090
// module chunks = 8